module.exports = "<div id=\"sticky-wrapper\">\n    <div id=\"sticky-placeholder-top\"></div>\n    <div id=\"sticky-content\" ng-transclude></div>\n    <div id=\"sticky-placeholder-bottom\"></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-ui-components/src/sticky-cta/template.html
// module id = ../node_modules/xo-ui-components/src/sticky-cta/template.html
// module chunks = 0